import { SelectionGroup, SelectionItem } from "../../Components/Selection/Selection";
import { LightIcon } from "../../AssetComponents/Images";
import { useOnboarding } from "./OnBoarding1";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export const RentalNavigation1 = () => {
  const location = useLocation();
  const { startOnboarding, isOnboarding, currentStep } = useOnboarding();
  
  useEffect(() => {
    // Check if this is the first visit to onboarding route and start onboarding properly
    if (location.pathname === '/rent/onboarding') {
      const hasSeenOnboarding = localStorage.getItem('hasSeenOnboarding');
      const onboardingStarted = sessionStorage.getItem('onboarding_started');
      
      console.log('RentalNavigation1 - checking onboarding:', { hasSeenOnboarding, onboardingStarted, pathname: location.pathname });
      
      if (!hasSeenOnboarding && !onboardingStarted) {
        sessionStorage.setItem('onboarding_started', 'true');
        // Add a small delay to ensure components are mounted
        setTimeout(() => {
          console.log('Starting onboarding from RentalNavigation1...');
          startOnboarding();
        }, 100);
      }
    }
  }, [location, startOnboarding]);

  // Add highlighting during onboarding step 5 (navigation step)
  const isHighlighted = isOnboarding && currentStep === 5;

  return (
    <SelectionGroup
      defaultItem={0}
      className={`border-[2px] border-[#e3e3e3] w-max px-[6px] py-[4px] gap-[8px] flex items-center rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${isHighlighted ? 'onboarding-highlight border-2 border-purple-500 ring-4 ring-purple-300 animate-pulse rounded-lg p-2' : ''}`}
    >
      <SelectionItem
        SelectedItem={
          <div className="py-[4px] cursor-pointer bg-white hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
            <div className="text-black font-semibold">All</div>
            <LightIcon />
          </div>
        }
        UnselectedItem={
          <div
            onClick={() => {}} // No navigation
            className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
          >
            <div className="text-[#959595]">All</div>
          </div>
        }
      />
      <SelectionItem
        SelectedItem={
          <div className="py-[4px] cursor-pointer bg-white hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
            <div className="text-black font-semibold">Long term</div>
            <LightIcon />
          </div>
        }
        UnselectedItem={
          <div
            onClick={() => {}} // No navigation
            className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
          >
            <div className="text-[#959595]">Long term</div>
          </div>
        }
      />
      <SelectionItem
        SelectedItem={
          <div className="py-[4px] cursor-pointer bg-white hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
            <div className="text-black font-semibold">Short term</div>
            <LightIcon />
          </div>
        }
        UnselectedItem={
          <div
            onClick={() => {}} // No navigation
            className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
          >
            <div className="text-[#959595]">Short term</div>
          </div>
        }
      />
    </SelectionGroup>
  );
};